export default __webpack_public_path__ + "static/cigus-en-e5db281a4ed74c3e6ecf95770d7550e0.svg";